/*
 * Keep a pre-order line's stored promise in step with the live metafield.
 *
 * `_preorder_promise` and `Pre-order` are captured at add-to-cart, so they are
 * a snapshot. Carts here belong to logged-in trade customers and survive for
 * weeks, while MOQbird can move a date at any time, so a cart can sit on a
 * promise the business no longer intends to keep. Checkout, the confirmation
 * email, the order status page and the packing slip all read those stored
 * properties, so the snapshot is what the entire downstream sees.
 *
 * Liquid already knows the answer without asking anyone: `dd-cart-item.liquid`
 * and `dd-cart-item-page.liquid` render the LIVE metafield date and, when it
 * differs from the captured one, stamp the line with the corrected values.
 * Nothing in this file queries the Storefront API or derives a date. It only
 * writes back what the server already decided, so the order record ends up
 * agreeing with the cart the buyer just read.
 *
 * Request budget per page load: zero when nothing drifted. When something did,
 * one GET /cart.js plus one /cart/change.js per drifted line.
 */
(function () {
  'use strict';

  if (window.__ddPreorderCartSync) return;
  window.__ddPreorderCartSync = true;

  /* One pass per page load, deliberately never reset. The pass rewrites the
     very markers it read, because cartMutate patches the cart sections, so an
     unbounded retry loop is the failure mode to design out rather than to
     detect afterwards. */
  var didPass = false;

  function collectJobs() {
    var nodes = document.querySelectorAll('[data-dd-po-sync-key]');
    var out = [];
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var job = {
        key: el.getAttribute('data-dd-po-sync-key'),
        iso: el.getAttribute('data-dd-po-sync-iso'),
        label: el.getAttribute('data-dd-po-sync-label'),
      };
      if (job.key && job.iso && job.label) out.push(job);
    }
    return out;
  }

  /* change.js REPLACES the whole properties hash for a line, so everything the
     line already carries has to be sent back with it. Dropping a key here would
     quietly strip shipping protection, a gift note, or a custom-order flag. */
  function mergedProperties(line, job) {
    var props = {};
    var existing = line.properties || {};
    for (var k in existing) {
      if (Object.prototype.hasOwnProperty.call(existing, k)) props[k] = existing[k];
    }
    props._preorder_promise = job.iso;
    props['Pre-order'] = job.label;
    return props;
  }

  function run() {
    if (didPass) return;
    var pending = collectJobs();
    if (!pending.length) return;

    var helpers = window.ddCartHelpers;
    if (!helpers || typeof helpers.cartMutate !== 'function') return;

    didPass = true;

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var byKey = {};
        var items = (cart && cart.items) || [];
        for (var i = 0; i < items.length; i++) byKey[items[i].key] = items[i];

        /* Sequential on purpose. Shopify serialises cart writes anyway, and
           cartMutate queues, patches the cart sections and publishes, so the
           re-rendered DOM comes back carrying the new line keys. Changing one
           line does not re-key the others, so the map stays valid across the
           chain. */
        return pending.reduce(function (chain, job) {
          return chain.then(function () {
            var line = byKey[job.key];
            if (!line) return null;
            return helpers.cartMutate(
              '/cart/change.js',
              { id: job.key, properties: mergedProperties(line, job) },
              { action: 'preorder-promise-sync', publishSource: 'preorder-sync' }
            );
          });
        }, Promise.resolve());
      })
      .catch(function (err) {
        /* A failed sync leaves the captured date in place. The cart still shows
           the live date, because Liquid rendered it, so the cost is an
           out-of-date order record rather than a page that lies. */
        console.warn('[dd-preorder-cart-sync]', err && err.message ? err.message : err);
      });
  }

  /* The cart drawer is server-rendered into every page, so both it and the cart
     page already hold their markers by this point. There is deliberately no
     cart-update listener: a single pass is the whole design. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
})();
